/* hc-judgeme-badge — Enhance Judge.me preview badge */

(function () {
  'use strict';

  var SEE_ALL_TEXT = 'See all reviews \u2193';
  var ENHANCE_TIMEOUT = 10000;
  var observer = null;

  function enhance(widget) {
    if (widget.classList.contains('hc-jdgm-enhanced')) return;

    var badge = widget.querySelector('.jdgm-prev-badge');
    if (!badge) return;

    widget.classList.add('hc-jdgm-enhanced');

    var stars = badge.querySelector('.jdgm-prev-badge__stars');
    var text = badge.querySelector('.jdgm-prev-badge__text');
    if (!stars || !text) return;

    if (!badge.querySelector('.hc-jdgm-left')) {
      var left = document.createElement('div');
      left.className = 'hc-jdgm-left';
      badge.insertBefore(left, stars);
      left.appendChild(stars);
      left.appendChild(text);
    }

    if (!badge.querySelector('.hc-jdgm-see-all')) {
      var reviewWidget = document.getElementById('judgeme_product_reviews');
      var link = document.createElement('a');
      link.className = 'hc-jdgm-see-all';
      link.textContent = SEE_ALL_TEXT;
      link.href = reviewWidget ? '#judgeme_product_reviews' : '#';

      if (!reviewWidget) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var el = document.querySelector('.jdgm-widget.jdgm-review-widget') ||
                   document.querySelector('[data-widget-name="review_widget"]');
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      badge.appendChild(link);
    }
  }

  function tryEnhance() {
    var widget = document.querySelector('.jdgm-preview-badge');
    if (!widget) return false;

    if (widget.classList.contains('hc-jdgm-enhanced')) return true;

    var badge = widget.querySelector('.jdgm-prev-badge');
    if (!badge) return false;

    if (window.getComputedStyle(badge).display === 'none') return false;

    enhance(widget);
    return true;
  }

  /**
   * Re-initialize after AJAX section swap.
   * Called by hc-product-variant-picker-v2.js after sibling navigation.
   */
  function reinit() {
    // Wait for Judge.me to inject its widget into the new DOM
    var attempts = 0;
    var maxAttempts = 40; // 40 × 250ms = 10s

    var poll = setInterval(function () {
      attempts++;
      if (tryEnhance() || attempts >= maxAttempts) {
        clearInterval(poll);
      }
    }, 250);
  }

  window.hcJudgemeBadgeReinit = reinit;

  if (tryEnhance()) return;

  observer = new MutationObserver(function () {
    if (tryEnhance()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  setTimeout(function () {
    if (observer) observer.disconnect();
    var widget = document.querySelector('.jdgm-preview-badge');
    if (widget && !widget.classList.contains('hc-jdgm-enhanced')) {
      var badge = widget.querySelector('.jdgm-prev-badge');
      if (badge) {
        badge.style.removeProperty('display');
        enhance(widget);
      }
    }
  }, ENHANCE_TIMEOUT);
})();
